// extracted by mini-css-extract-plugin
export default {"controlContainer":"style_controlContainer__V8+ZU","Mini":"style_Mini__8nhSU","control":"style_control__kXjke","controlMini":"style_controlMini__+-7NG"};